import { VHeaders } from '@/models/pagedlistmodel';

export function getHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('lanes.laneGridHeaders.laneId') as string,
      align: 'left',
      value: 'laneId',
    },
    {
      text: vm.$parent.$t('lanes.laneGridHeaders.terminalId') as string,
      align: 'left',
      value: 'terminalId',
    },
    {
      text: vm.$parent.$t('lanes.laneGridHeaders.serial') as string,
      align: 'left',
      value: 'serialNumber',
    },
    {
      text: vm.$parent.$t('lanes.laneGridHeaders.description') as string,
      align: 'left',
      value: 'description',
    },
    {
      text: vm.$parent.$t('lanes.laneGridHeaders.status') as string,
      align: 'left',
      value: 'isActivated',
      filters: [
        (val) => {
          return val && val !== 'N/A' ? 'Activated' : 'InActive';
        },
      ],
    },
    {
      text: vm.$parent.$t('lanes.laneGridHeaders.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}
export function getLaneHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('lanes.laneHistoryGridHeaders.status') as string,
      align: 'left',
      value: 'status',
    },
    {
      align: 'left',
      text: vm.$parent.$t('lanes.laneHistoryGridHeaders.timeStamp') as string,
      value: 'timeStamp',
      fieldType: 'date',
    },
  ];
}
